function getThemeRoutes() {
  if (typeof routes !== 'undefined') return routes;
  return window.routes || {};
}

function getCheckoutUrl() {
  const themeRoutes = getThemeRoutes();
  if (themeRoutes.checkout_url) return themeRoutes.checkout_url;
  const shopifyRoot = window.Shopify?.routes?.root;
  if (shopifyRoot) return `${shopifyRoot}checkout`;
  return '/checkout';
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        if (this.variantIdInput) this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.buyNowButtons = this.querySelectorAll('[data-buy-now], [name="buy-now"]');
        this.buyNowButtons.forEach((button) => {
          button.removeAttribute('onclick');
          button.addEventListener('click', this.onBuyNowHandler.bind(this));
        });
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');
        this.loadingSpinner = this.querySelector('.loading__spinner');

        if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }


      selectedInstallationVariantId() {
        const input = this.form.querySelector('[data-tcl-installation-service]:not(:disabled)');
        return input ? Number(input.dataset.serviceVariantId) : null;
      }

      installationCartItems(formData, installationVariantId) {
        const tvVariantId = Number(formData.get('id'));
        const quantity = Math.max(1, Number(formData.get('quantity')) || 1);
        const properties = {};

        for (const [name, value] of formData.entries()) {
          const match = name.match(/^properties\[(.+)\]$/);
          if (match && value) properties[match[1]] = value;
        }

        const tvItem = { id: tvVariantId, quantity };
        if (Object.keys(properties).length) tvItem.properties = properties;
        if (formData.get('selling_plan')) tvItem.selling_plan = Number(formData.get('selling_plan'));

        return {
          items: [tvItem, { id: installationVariantId, quantity, parent_id: tvVariantId }],
        };
      }
      
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton?.setAttribute('aria-disabled', true);
        this.submitButton?.classList.add('loading');
        this.loadingSpinner?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const installationVariantId = this.selectedInstallationVariantId();

        if (this.cart && !installationVariantId) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (installationVariantId) {
          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(this.installationCartItems(formData, installationVariantId));
        } else {
          config.body = formData;
        }

        const themeRoutes = getThemeRoutes();
        const cartAddUrl =
          themeRoutes.cart_add_url ||
          (window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js');

        fetch(`${cartAddUrl}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton?.setAttribute('aria-disabled', true);
              this.submitButtonText?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
              } else if (installationVariantId) {
                this.error = false;
                document.dispatchEvent(
                  new CustomEvent('lcu:cart:toggle', { detail: { open: true } })
                );
                return;
              } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton?.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton?.removeAttribute('aria-disabled');
            this.loadingSpinner?.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      onBuyNowHandler(event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const buyNowButton = event.currentTarget;
        if (buyNowButton.getAttribute('aria-disabled') === 'true' || buyNowButton.disabled) return;

        const variantId = this.variantIdInput?.value;
        if (!variantId) return;

        const quantityInput =
          this.form.querySelector('.quantity__input') ||
          document.getElementById(`Quantity-${this.dataset.sectionId}`);
        const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
        const installationVariantId = this.selectedInstallationVariantId();
        const formData = new FormData(this.form);
        formData.set('id', variantId);
        formData.set('quantity', String(quantity));

        this.handleErrorMessage();

        buyNowButton.setAttribute('aria-disabled', 'true');
        buyNowButton.disabled = true;

        const themeRoutes = getThemeRoutes();
        const cartAddUrl =
          themeRoutes.cart_add_url ||
          (window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js');

        fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify(
            installationVariantId
              ? this.installationCartItems(formData, installationVariantId)
              : { id: parseInt(variantId, 10), quantity }
          ),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status) {
              this.handleErrorMessage(data.description || data.message);
              return;
            }
            window.location.replace(getCheckoutUrl());
          })
          .catch((error) => {
            console.error(error);
            this.handleErrorMessage();
          })
          .finally(() => {
            buyNowButton.removeAttribute('aria-disabled');
            buyNowButton.disabled = false;
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton?.setAttribute('disabled', 'disabled');
          this.buyNowButtons?.forEach((button) => {
            button.setAttribute('aria-disabled', 'true');
            button.disabled = true;
          });
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton?.removeAttribute('disabled');
          this.buyNowButtons?.forEach((button) => {
            button.removeAttribute('aria-disabled');
            button.disabled = false;
          });
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form?.querySelector('[name=id]');
      }
    }
  );
}
